import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  makeStyles,
} from "@material-ui/core";
import { constants } from "../../../constants/constants";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";

const DMSelect = ({
  id,
  label,
  lists,
  onChange,
  defaultValue = null,
  intl,
  styles = {},
}) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      width: "100%",
      '& .MuiSelect-root' : {
          padding: '10px'
      }
    },
    inputLabel: {
      fontSize: "12px",
    },
  }));

  const classes = useStyles();

  const [selection, setSelection] = useState();
  const handleChange = (e) => {
    setSelection(e.target.value);
    onChange(e.target.value);
  };

  useEffect(() => {
    if (defaultValue) {
      setSelection(defaultValue);
      onChange(defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      <FormControl
        variant="outlined"
        className={classes.formControl}
        style={{ marginRight: "5px", minWidth: styles?.width || "222px", width: "fit-content" }}
      >
        <InputLabel id="model-label-id" style={{background: "#efeff3"}}>{label}</InputLabel>
        <Select
          labelId={id + "-label"}
          id={id}
          label={label}
          variant="outlined"
          value={selection}
          className={classes.modelid}
          onChange={handleChange}
          defaultValue={defaultValue}
          style={styles}
        >
          {!!lists?.length &&
            lists?.map((item, index) => {
              return (
                <MenuItem value={item.value}>
                  {item.name
                    ? injectIntlTranslation(
                        intl,
                        item?.name,
                        constants[item?.name]
                      )
                    : injectIntlTranslation(intl, item?.label, item?.label)}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>

      {/* <FormControl className={classes.formControl} style={{marginRight: "5px"}}>
      <InputLabel className={classes.inputLabel} id={id + "-label"}>
        {label}
      </InputLabel>
      <Select
        labelId={id + "-label"}
        label={label}
        id={id}
        value={selection}
        MenuProps={{
          // classes: { paper: paperMenu },
          variant: "menu",
          getContentAnchorEl: null,
          autoFocus: true,
        }}
        inputProps={{ "aria-label": "Without label" }}
        disableUnderline
        onChange={handleChange}
        defaultValue={defaultValue}
        style={styles}
      >
        {!!lists?.length &&
          lists?.map((item, index) => {
            return (
              <MenuItem value={item.value}>
                {item.name
                  ? injectIntlTranslation(
                      intl,
                      item?.name,
                      constants[item?.name]
                    )
                  :  injectIntlTranslation(
                    intl,
                    item?.label,
                    item?.label
                  )}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl> */}
    </>
  );
};

export default injectIntl(DMSelect);
